import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { CdsMetadata } from '../class/cds-metadata';
import { CDSMetadata } from '../class/CDSMetadata';
declare var userInfo: any;

@Injectable({
	providedIn: 'root'
})
export class CdsHttpService {

	private http: HttpClient;
	request: any = {
		"get": this.get.bind(this),
		"post": this.post.bind(this),
		"put": this.put.bind(this),
		"delete": this.delete.bind(this)
	};

	constructor(
		private backend: HttpBackend
	) {
		this.http = new HttpClient(this.backend);

	}

	/**
	 * 
	 * @param values 
	 * @description creates http header
	 */
	private getHttpHeaders(values): Object {
		
		const headers: Map<string,any> = new Map();
		let dummyMap:Map<string,any>=new Map(Object.entries(values));		
			const token = (userInfo.Token ? userInfo.Token : userInfo.token);
			dummyMap.delete("no-cookie");
			dummyMap.delete("cookie");
			if (!dummyMap.has("no-authorization")){ headers.set('Authorization', 'Bearer ' + token);}else{dummyMap.delete("no-authorization"); }
			if (!dummyMap.has('Ocp-Apim-Subscription-Key')) headers.set('Ocp-Apim-Subscription-Key', userInfo.OcpApimSubscriptionKey);
			if (dummyMap.has('userexecutioncontext')) headers.set('userexecutioncontext', JSON.stringify(userInfo.UserContext));
			if (dummyMap.has('requestverificationtoken')) headers.set('requestverificationtoken', userInfo.requestverificationtoken);
			//enable CoorelationId 
			headers.set('x-gep-transaction-scope-id', this.getGUID());
			// fixing none collable eterator issue.
			// adding this eterator to copy the headers being passed from the portal/project-team end to create a new header and pss them into
			dummyMap.forEach((value,key) => {
				if(!headers.has(key)) headers.set(key, value);
				
			})
		return new HttpHeaders(Object['fromEntries'](headers));
	}

	public createHttpMethod(options: CDSMetadata): Observable<any>;

	public createHttpMethod(options: CdsMetadata): Observable<any>;

	public createHttpMethod(options: any): Observable<any> {
		const header = this.getHttpHeaders(options.headers);
		const httpOptions:any={headers:header};
		if (options.queryParams) httpOptions['params'] = options.queryParams;
		if (options.responseType) httpOptions['responseType'] = options.responseType;
		httpOptions["withCredentials"]= Object(options.headers).hasOwnProperty("cookie")?true:false;
		return this.request[options.method.toLowerCase()](this.getBaseURL(options.endpoint), httpOptions, options.payload);
	}


	private getGUID() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
			return v.toString(16);
		});
	}

	getBaseURL(url:string){
		if(!url.startsWith("http")){
			return userInfo.ApiUrlBase + url;
		}
		return url;
	}
	// #region requests

	/**
	 * 
	 * @param endpoint 
	 * @param options 
	 * @description creates http get method
	 */
	get(endpoint, options): Observable<any> {
		return this.http.get(endpoint, options);
	}

	/**
	 * 
	 * @param endpoint 
	 * @param params 
	 * @param options
	 * @description creates post method 
	 */
	post(endpoint, options, params): Observable<any> {
		return this.http.post(endpoint, params, options);
	}

	put(endpoint, options, params): Observable<any> {
		return this.http.put(endpoint, params, options);
	}

	delete(endpoint, options): Observable<any> {
		return this.http.delete(endpoint, options);
	}

	// #endregion

}
